import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';

import { NgxLoggerService } from './logger.service';

export const ngxLoggerServiceModule = angular.module('ngxLoggerServiceModule', [])
	.factory('ngxLoggerService', downgradeInjectable(NgxLoggerService) as any)
	.name;
